import { classNames } from "@/shared/utils/classnames";
import { FC } from "react";

type HistoryProps = {
  name: string;
  description: string;
  date: string;
  hour?: string;
};

type ListHistorialProps = {
  history: HistoryProps[];
};

export const ListHistorial: FC<ListHistorialProps> = ({ history }) => {
  return (
    <>
      <ul role="list" className="space-y-6 mt-3">
        {history.map((hystoryObjetc, activityItemIdx) => (
          <li key={activityItemIdx} className="relative flex gap-x-4">
            <div
              className={classNames(
                activityItemIdx === history.length - 1 ? "h-6" : "-bottom-6",
                "absolute left-0 top-0 flex w-6 justify-center"
              )}
            >
              <div className="w-px bg-gray-200" />
            </div>

            <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
              <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300" />
            </div>
            <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
              <span className="font-medium text-gray-900">
                {hystoryObjetc.name}
              </span>{" "}
              {hystoryObjetc.description}
            </p>
            <time className="flex-none py-0.5 text-xs leading-5 text-gray-500">
              {hystoryObjetc.date}
            </time>
            {hystoryObjetc.hour && (
              <time className="flex-none py-0.5 text-xs leading-5 text-gray-500">
                {hystoryObjetc.hour}
              </time>
            )}
          </li>
        ))}
      </ul>
    </>
  );
};